import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useApp from "../context/AppContext";
import { api } from "../utils/api";
import { randomizeEmail } from "../utils/functions";

const CodigoAtivacao = () => {
  const [codAtivacao, setCodAtivacao] = useState("");
  const { userAtivacao, showModalMessage, showModalError, emailAtivacao, setLoading,closeModal } = useApp();
  const navigate = useNavigate();
  const classCodigo = codAtivacao === "" ? "input100" : "input100 has-val";
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    setLoading(true);
    api().post("/auth/alterarSenha", { username: userAtivacao, codAtivacao: codAtivacao.trim() })
      .then((resp) => {
        if (resp.status === 200) {
          navigate("/login");
          showModalMessage(
            "ATIVAÇÂO DE CONTA",
            <>
              <h2>Ativação concluída com sucesso!</h2>
              <p>
                Faça o <button onClick={() => closeModal()}>login</button> para acessar o sistema.
              </p>
            </>
          );
        } else {
          showModalError(resp.data);
        }
        setLoading(false);
      })
      .catch(function (error) {
        showModalError(error.response.data);
        setLoading(false);
      });
    event.preventDefault();
  };
  const reenviaEmail = () => {
    api()
      .post("/auth/reenviarEmail", { emailAtivacao })
      .then((resp) => {
        if (resp.status === 200) {
          showModalMessage("REENVIO DE CÓDIGO", <h2>O código foi enviado para o email: {randomizeEmail(emailAtivacao)}</h2>);
        } 
        else {
          showModalMessage("Erro", <p>{resp.data}</p>);
        }
      })
      .catch(function (error) {
        if (error.response.status === 406) {
          showModalMessage(
            "NFS-Recebimento",
            <>
              <h2>O CNPJ informado não possui e-mail cadastrado!</h2>
              <p>Para gerar uma senha de acesso é necessário ter um e-mail cadastrado em nosso sistema.</p>
              <p>
                Por favor, entre em contato com o <b>Departamento de Compras</b> pelo telefone: + 55 (12) 3908-XXXX
              </p>
            </>
          );
        } else {
          showModalMessage("Erro", <p>{error.response.data}</p>);
        }
      });
  };
  return (
    <>
      <div className="limiter bghome">
        <div className="container-login100">
          <div className="wrap-login100">
            <form className="login100-form validate-form" onSubmit={handleSubmit}>
              <span className="login100-form-other">Código de Ativação</span>
              <span className="login100-form-subtitle">Portal de Fornecedores</span>
              <span className="login100-form-msg">O código foi enviado para o email: {randomizeEmail(emailAtivacao)}</span>

              <div className="wrap-input100 validate-input m-t-55 m-b-35" data-validate="Enter username">
                <input
                  type="text"
                  className={classCodigo}
                  value={codAtivacao}
                  onChange={(e) => setCodAtivacao(e.currentTarget.value)}
                  name="codigo"
                  required
                />
                <span className="focus-input100" data-placeholder="Código"></span>
              </div>

              <div className="container-login100-form-btn">
                <button className="login100-form-btn">VALIDAR</button>
              </div>

              <ul className="login-more p-t-60 ps-0">
                <li>
                  <span className="txt1">Nada em sua caixa de entrada? </span>
                  <span className="txt1">Checou sua caixa de Spam? </span>
                  <button className="txt2" onClick={reenviaEmail}>
                    Reenviar o código de ativação
                  </button>
                </li>
                <li>
                  <span className="txt1">
                    Já ativou sua conta? Faça o{" "}
                    <Link to="/login" className="txt2">login </Link>
                    para acessar o sistema.
                  </span>
                </li>
              </ul>
            </form>            
            <span className="urbam_footer">URBAM - URBANIZADORA MUNICIPAL S.A</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default CodigoAtivacao;
